"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merge_1 = __importDefault(require("lodash/merge"));
/**
 *
 * @param {Object|Boolean} input
 * @returns {Object} typeof obj.open === 'boolean'
 */
var parseBoundary = function (input) {
    if (input === undefined || input === null) {
        return {};
    }
    return typeof input === "boolean"
        ? { open: input }
        : __assign({ open: true }, input);
};
function getContextProps(props, context, displayName) {
    var prefix = props.prefix, locale = props.locale, pure = props.pure, rtl = props.rtl, device = props.device, popupContainer = props.popupContainer, errorBoundary = props.errorBoundary;
    var nextPrefix = context.nextPrefix, nextLocale = context.nextLocale, nextDefaultPropsConfig = context.nextDefaultPropsConfig, nextPure = context.nextPure, nextWarning = context.nextWarning, nextRtl = context.nextRtl, nextDevice = context.nextDevice, nextPopupContainer = context.nextPopupContainer, nextErrorBoundary = context.nextErrorBoundary;
    var newPrefix = prefix || nextPrefix;
    var localeFromContext;
    var newDisplayName = displayName;
    switch (displayName) {
        case "DatePicker2":
            newDisplayName = "DatePicker";
            break;
        case "Calendar2":
            newDisplayName = "Calendar";
            break;
        case "TimePicker2":
            newDisplayName = "TimePicker";
            break;
        default:
            break;
    }
    if (nextLocale) {
        localeFromContext = nextLocale[newDisplayName];
        if (localeFromContext) {
            localeFromContext.momentLocale = nextLocale.momentLocale;
        }
    }
    var newLocale;
    if (locale) {
        newLocale = (0, merge_1.default)({}, localeFromContext, locale);
    }
    else if (localeFromContext) {
        newLocale = (0, merge_1.default)({}, localeFromContext);
    }
    var newPure = typeof pure === "boolean" ? pure : nextPure;
    var newRtl = typeof rtl === "boolean" ? rtl : nextRtl;
    // ProtoType of [nextE|e]rrorBoundary can be one of [boolean, object]
    // but typeof newErrorBoundary === 'object'
    // newErrorBoundary should always have the key 'open', which indicates ErrorBoundary on or off
    var newErrorBoundary = __assign(__assign({}, parseBoundary(nextErrorBoundary)), parseBoundary(errorBoundary));
    if (!("open" in newErrorBoundary)) {
        newErrorBoundary.open = false;
    }
    return {
        prefix: newPrefix,
        locale: newLocale,
        pure: newPure,
        rtl: newRtl,
        warning: nextWarning,
        defaultPropsConfig: nextDefaultPropsConfig || {},
        device: device || nextDevice || undefined,
        popupContainer: popupContainer || nextPopupContainer,
        errorBoundary: newErrorBoundary,
    };
}
exports.default = getContextProps;
